import { ShortVideoContentItemProps } from '@components/report/content-items/short-video-content-item/ShortVideoContentItem';

import { IGContentData, IGReportRes } from '@apis/orval/model';

import { VideoContentIgProps } from './VideoContentIg';

export class VideoContentIgAdapter {
	value: IGReportRes;
	constructor(obj: IGReportRes) {
		this.value = obj;
	}

	get videoContents() {
		return this.value?.content?.recent_video_contents ?? [];
	}

	sortContents(contents: IGContentData[], sortBy: 'newest' | 'views') {
		if (sortBy === 'newest')
			return contents.sort(
				(a, b) =>
					new Date(b.upload_at ?? 0).getTime() - new Date(a.upload_at ?? 0).getTime(),
			);
		else if (sortBy === 'views')
			return contents.sort(
				(a, b) => (b.video_view_count ?? 0) - (a.video_view_count ?? 0),
			);

		return contents;
	}

	getFeedContentItemProps(videoContentData: IGContentData): ShortVideoContentItemProps {
		return {
			outLink: videoContentData.content_link ?? undefined,
			imgSrc: videoContentData.content_img_link ?? undefined,
			viewCount: videoContentData.video_view_count ?? undefined,
			contentText: videoContentData.description ?? undefined,
			isPaidAd: undefined,
		};
	}

	adapt(sortBy: 'newest' | 'views'): VideoContentIgProps {
		return {
			items: this.sortContents(this.videoContents, sortBy).map((videoContentData) =>
				this.getFeedContentItemProps(videoContentData),
			),
		};
	}
}
